import React, { useRef, useEffect, useState } from "react";
import UserPolyPage from "./UserPolyPage";
import axios from "axios";
import { fetchrootpath } from "../../api_servcies/apirootpath";

function UserPolyContainer (props) {
  const listInnerRef = useRef();
  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [userpoly, setUserpoly] = useState([]);
  const [lastList, setLastList] = useState(false);

  const user_data = JSON.parse(sessionStorage.getItem('user'))

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `${fetchrootpath}/user_project`,
        {
          params:{
            email_id: user_data.email_id,
            currPage: currPage,
            size: 10
          }
        }
      );
      if (!response.data.length) {
        setLastList(true);
        return;
      }
      setPrevPage(currPage);
      setUserpoly([...userpoly, ...response.data]);
    };
    if (!lastList && prevPage !== currPage) {
      fetchData();
    }
  }, [currPage, lastList, prevPage, userpoly]);

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        setCurrPage(currPage + 1);
      }
    }
  };

  return (
    <UserPolyPage
      onScroll={onScroll}
      listInnerRef={listInnerRef}
      userpoly={userpoly}
    />
  );
}

export default UserPolyContainer;
